import React from 'react';
import { FaUserTie, FaUsers, FaChartLine, FaStepForward } from 'react-icons/fa';
import CardsSection from '../../components/CardsSection/CardsSection';

const missionItems = [
  {
    icon: <FaUserTie />,
    title: "Professioneller Ansatz",
    description: "Wir legen großen Wert auf ein professionelles Auftreten und höchste Sorgfalt in jedem Projekt. Durch unsere langjährige Erfahrung können wir nachhaltige Ergebnisse liefern."
  },
  {
    icon: <FaUsers />,
    title: "Individueller Ansatz",
    description: "Jeder Kunde ist einzigartig. Wir passen unsere Lösungen individuell an, um sicherzustellen, dass Ziele und Bedürfnisse optimal berücksichtigt werden."
  },
  {
    icon: <FaChartLine />,
    title: "Integrierte Analysen",
    description: "Wir integrieren fortschrittliche Analysen, damit datenbasierte Entscheidungen getroffen werden können. So erhalten unsere Kunden wertvolle Einblicke in ihr Geschäft."
  },
  {
    icon: <FaStepForward />,
    title: "Schritt-für-Schritt-Vorgehen",
    description: "Mit unserem klar strukturierten Vorgehen behalten wir stets den Überblick. Schritt für Schritt realisieren wir zuverlässige und effiziente Lösungen."
  }
];

const OurMissionSection = () => {
  return (
    <CardsSection 
      title="UNSERE MISSION"
      items={missionItems}
      sectionClass="mission-section" /* Optional: extra class names for styling */
    />
  );
};

export default OurMissionSection;
